import { getBackRoyalApiBaseConfig } from 'BackRoyalApi';
import { createApi } from 'ReduxHelpers';
import {
    type CreatedTimelineEventResponse,
    type CreateTimelineNoteArgs,
    type TimelineEvent,
    type UserTimelineResponse,
} from '../ActivityTimelineTab.types';

export const activityTimelineApi = createApi('activityTimelineApi', {
    ...getBackRoyalApiBaseConfig('activityTimelineApi'),
    endpoints: builder => ({
        getUserTimeline: builder.query<TimelineEvent[], string>({
            query: userId => ({ url: `user_timelines/${userId}` }),
            transformResponse: (response: UserTimelineResponse) => response.contents.userTimelines?.[0]?.events ?? [],
        }),

        createTimelineNote: builder.mutation<string, CreateTimelineNoteArgs>({
            query: ({ userId, text, time }) => ({
                method: 'post',
                url: 'persisted_timeline_events',
                body: {
                    record: {
                        category: 'note',
                        event: 'note',
                        time,
                        text,
                    },
                    // The meta tells the server which record owns the timeline this event belongs to.
                    meta: { object: 'user', objectId: userId },
                },
            }),
            transformResponse: (response: CreatedTimelineEventResponse) =>
                response.contents.persistedTimelineEvents[0].id,
        }),

        deleteTimelineNote: builder.mutation<void, string>({
            query: id => ({ method: 'delete', url: `persisted_timeline_events/${id}` }),
        }),
    }),
});
